import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";
import type { TransitionMeasure } from "@/contexts/wizard/types";

export interface TransitionOtherActionCardProps {
  measures: TransitionMeasure[]; // already filtered to actionId === "other" for this topic
  disabled?: boolean;
  onAdd: () => void;
  onRemove: (measureId: string) => void;
  onLabelChange: (measureId: string, label: string) => void;
  renderRow: (measure: TransitionMeasure) => React.ReactNode; // caller supplies TransitionActionRow body
}

export function TransitionOtherActionCard({ measures, disabled, onAdd, onRemove, onLabelChange, renderRow }: TransitionOtherActionCardProps) {
  return (
    <div className="space-y-3">
      {measures.map((measure) => (
        <div key={measure.id} className="overflow-hidden rounded-[22px] border border-slate-200 bg-white">
          <div className="flex items-center gap-2 px-4 pt-4">
            <Input
              value={measure.otherLabel || ""}
              onChange={(e) => onLabelChange(measure.id, e.target.value)}
              placeholder="Describe the action"
              disabled={disabled}
              className="h-9 rounded-xl border-slate-200 bg-slate-50 text-sm"
            />
            <Button type="button" variant="ghost" size="icon" disabled={disabled} onClick={() => onRemove(measure.id)}>
              <Trash2 className="h-4 w-4 text-slate-400" />
            </Button>
          </div>
          {renderRow(measure)}
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" disabled={disabled} onClick={onAdd} className="rounded-2xl">
        <Plus className="mr-2 h-4 w-4" /> Add other action
      </Button>
    </div>
  );
}
